import type { FiltrosReporteOdf } from '../types'

interface FiltrosBarProps {
  filtros: FiltrosReporteOdf
  onChange: (filtros: FiltrosReporteOdf) => void
}

const TIPOS = [
  { value: '', label: 'Todos los tipos' },
  { value: 'articulo', label: 'Artículo' },
  { value: 'podcast', label: 'Podcast' },
]

const ACCIONES = [
  { value: '', label: 'Todas las acciones' },
  { value: 'leer', label: 'Leer' },
  { value: 'descargar', label: 'Descargar' },
  { value: 'escuchar', label: 'Escuchar' },
]

export function FiltrosBar({ filtros, onChange }: FiltrosBarProps) {
  const set = (patch: Partial<FiltrosReporteOdf>) => onChange({ ...filtros, ...patch })

  return (
    <div className="flex flex-wrap gap-3 items-end">
      {/* Desde */}
      <div className="flex flex-col gap-1 min-w-[140px]">
        <label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
          Desde
        </label>
        <input
          type="date"
          value={filtros.desde ?? ''}
          onChange={(e) => set({ desde: e.target.value || undefined })}
          className="h-9 rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-ring"
        />
      </div>

      {/* Hasta */}
      <div className="flex flex-col gap-1 min-w-[140px]">
        <label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
          Hasta
        </label>
        <input
          type="date"
          value={filtros.hasta ?? ''}
          onChange={(e) => set({ hasta: e.target.value || undefined })}
          className="h-9 rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-ring"
        />
      </div>

      {/* Especialidad */}
      <div className="flex flex-col gap-1 min-w-[160px]">
        <label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
          Especialidad
        </label>
        <input
          type="text"
          placeholder="Todas"
          value={filtros.especialidad ?? ''}
          onChange={(e) => set({ especialidad: e.target.value || undefined })}
          className="h-9 rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-ring"
        />
      </div>

      {/* Provincia */}
      <div className="flex flex-col gap-1 min-w-[160px]">
        <label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
          Provincia
        </label>
        <input
          type="text"
          placeholder="Todas"
          value={filtros.provincia ?? ''}
          onChange={(e) => set({ provincia: e.target.value || undefined })}
          className="h-9 rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-ring"
        />
      </div>

      {/* Tipo */}
      <div className="flex flex-col gap-1 min-w-[160px]">
        <label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
          Tipo
        </label>
        <select
          value={filtros.tipo ?? ''}
          onChange={(e) => set({ tipo: e.target.value || undefined })}
          className="h-9 rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-ring"
        >
          {TIPOS.map((t) => (
            <option key={t.value} value={t.value}>
              {t.label}
            </option>
          ))}
        </select>
      </div>

      {/* Acción */}
      <div className="flex flex-col gap-1 min-w-[180px]">
        <label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
          Acción
        </label>
        <select
          value={filtros.accion ?? ''}
          onChange={(e) => set({ accion: e.target.value || undefined })}
          className="h-9 rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-ring"
        >
          {ACCIONES.map((a) => (
            <option key={a.value} value={a.value}>
              {a.label}
            </option>
          ))}
        </select>
      </div>

      {/* Limpiar */}
      <button
        type="button"
        onClick={() => onChange({})}
        className="h-9 px-3 rounded-md border border-input bg-background text-sm text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
      >
        Limpiar
      </button>
    </div>
  )
}
